import {useContext} from "react";

import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {SSOTab} from "@/pages/statuspages/tabs/sso/SSOTab.tsx";

export const StatusPageSSOTab = () => {
  const {statusPage, testIDPs} = useContext(StatusPageContext);
  return <SSOTab statusPageID={statusPage.id} samlSettings={statusPage.samlSettings} testIDPs={testIDPs.items} />;
};
